export default __webpack_public_path__ + "static/media/display_japandi.b81402cd.png";